import { bb } from "$json";
/* model-modes:
 *
 * Toggle modes based on serverinstructions
 *
 * The alledged 'modes' then are checked for the following:
 *
 * starts with 'modelHas' : the mode will be set with bb.Mode.set()
 *
 * starts with '-modelHas': the mode will be set with bb.Mode.unset()
 *
 * anything else is ignored
 *
 * One may e.g. either use the following JSON syntax:

       {
           "plugins": {
               "model-modes": [
                   "modelHasNoSkip",
                   "-modelHasNoPrior"
               ]
           }
       }

   or simply

       modelHasNoSkip -modelHasNoPrior

   in the serverinstructions, where the serverinstructions are then
   split on non-ascii chars.
 *
 *
 * Author: Niels Giesen Copyright 2018 Berkeley Bridge
 *
 */
(function ($, win, doc) {
  var pluginName = "model-modes",
    prev = {};

  function unsetwhennotin(these) {
    if (these === undefined) {
      these = {};
    }
    Object.keys(prev).forEach(function (key) {
      if (key.substr(0, 8) === "modelHas" && these[key] === undefined) {
        bb.Mode.unset(key);
      }
    });
    return these;
  }

  $(function () {
    $(doc).on("bb:postHandleData", function (event, data) {
      if (data) {
        if (bb.Mode.get("hasModel")) {
          var these = {},
            json,
            tags;
          try {
            json = JSON.parse(data.serverinstructions);
            if (json.plugins && json.plugins[pluginName]) {
              if (Array.isArray(json.plugins[pluginName]))
                tags = json.plugins[pluginName];
            }
          } catch (e) {
            tags =
              data.serverinstructions &&
              data.serverinstructions.split(/[^-A-z]+/);
          }
          if (tags)
            tags.forEach(function (instr) {
              if (these[instr]) {
                return;
              }
              if (instr.substr(0, 8) === "modelHas") {
                bb.Mode.set(instr);
                these[instr] = true;
                return;
              }
              if (instr.substr(0, 9) === "-modelHas") {
                bb.Mode.unset(instr.substr(1));
                these[instr] = true;
                return;
              }
            });
          prev = unsetwhennotin(these);
        } else {
          prev = unsetwhennotin({});
        }
      }
    });
  });
})(jQuery, window, document);
